module.exports = __webpack_public_path__ + "img/mintNetworkLogoPOLYGON.591aa63a.svg";